import React from "react";
import FactoryFields from './factory-fields';


const TRowBody = ({ values, optionsRow, children, onChange = () => {}, innerRef, ...props }) => {
  return (
    <tr {...props} ref={innerRef}>
      {values.map(([key, value]) => (
        <th key={key}>
          <FactoryFields
            fieldName={key}
            onChange={onChange}
            type={optionsRow.input[key]}
            value={value}
          />
        </th>
      ))}
      {children}
    </tr>
  );
};

export default TRowBody;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/TRowBody.js